import StartEndDurationUtils from "../start-end-duration/start-end-duration-utils";
import DateTimeUtils from "../../../gd/utils/datetime-utils";

export enum WorkScheduleDayStatus {

    COMPANY_HOLIDAY         = 'company-holiday',        // if company holiday - ne rabotaem
    COMPANY_WEEKEND         = 'company-weekend',        // if company holiday - ne rabotaem

    USER_VACATION           = 'user-vacation',          // if user vacation - ne rabotaem
    USER_SICK_LEAVE         = 'user-sick-leave',        // if user sick - ne rabotaem
    USER_WEEKEND            = 'user-weekend',           // if user weekend - ne rabotaem;
    USER_BEFORE_CREATION    = 'user-before-creation',   // day is before the user was created

}

export default class WorkScheduleProto {

    public workDayDurations! : number[] // [480,480,480,480,480,0,0]

    updateEvents(companyEvents:any) {
        /*should be overridden*/
    }

    // careful with === for true
    isWorkingDay(dateString:any) : true | WorkScheduleDayStatus {
        /*should be overridden*/
        return true;
    }

    _isDateHoliday(date:any) {
        return this.isWorkingDay(DateTimeUtils.dateToMoment(date).format("YYYY-MM-DD")) !== true;
    }

    getWorkweekDuration(weekStartDateMoment: Moment) {
        const currentDate = weekStartDateMoment.clone()
        let duration = 0

        for(let i = 0; i <= 6; i++) {
            duration += this.getWorkdayDuration(currentDate)
            currentDate.add(1, 'day')
        }

        return duration
    }

    getWorkdayDuration(dateMoment: Moment) {
        return this.isWorkingDay(DateTimeUtils.momentToDate(dateMoment)!) ? 8*60 : 0
    }

    // used to calculate workday duration for tasks
    // return # of working days
    // VAZNO eto nelzya uzat' dlya LAG - eto imennno kol-ve rabochih dnei vnutri date range
    calculateWorkdays(daterange:MomentRange) {
        return StartEndDurationUtils.calculateWorkdaysHolidaysInRange(daterange.start,daterange.end, this._isDateHoliday.bind(this)).workdays.length;
    }

    calculateWorkdaysLag(daterange:MomentRange) {
        return StartEndDurationUtils.calculateWorkdaysLag(daterange.start,daterange.end, this._isDateHoliday.bind(this));
    }

    findFirstWorkingDay(momentRange:MomentRange) {
        return StartEndDurationUtils.findFirstWorkingDay(momentRange, this._isDateHoliday.bind(this));
    }

    // used to calculate end date according to tasks workday duration
    // return endDate Moment object that fits estimatedMinutes from startDate
    calculateEndDateByDuration(startDate:Moment, estimatedMinutes:number) {
        return StartEndDurationUtils.calculateEndDateByWorkdayDurations(startDate, estimatedMinutes, this.getWorkdayDuration.bind(this));
    }

    // used to calculate end date according to tasks workday duration
    // return endDate Moment object that fits targetWorkdays from startDate
    calculateEndDate(startDate:Moment, targetWorkdays:number) {
        return StartEndDurationUtils.calculateEndDateExcludingHolidays(startDate, targetWorkdays, this._isDateHoliday.bind(this));
    }

    // used to calculate start date
    // return endDate Moment object that fits targetWorkdays from startDate
    calculateStartDate(newStartDate:Moment, targetWorkdays:number) {
        return StartEndDurationUtils.calculateStartDateExcludingHolidays(newStartDate, targetWorkdays, this._isDateHoliday.bind(this));
    }

    addWorkdays(date:Moment, workdays:number) {
        return StartEndDurationUtils.addWorkdays(date, workdays, this._isDateHoliday.bind(this));
    }

    getCurrentOrNextWorkDay() {
        const currentDay = momentDate()

        while (this._isDateHoliday(currentDay)) {
            currentDay.add(1,'days')
        }

        return currentDay

    }
}